/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import sha1 from 'sha1';
import Axios from 'axios';
import { toast } from 'react-toastify';
import styles from './authentication.module.scss';
import LoginForm from './components/LoginForm';
import OTPLoginForm from './components/OTPLoginForm';
import OTPForm from './components/OTPForm';
import Loading from '../../../../components/loading';
import { isLocal, hostName } from '../../../../constants/apiEnv';
import {
  fetchUserApplications,
  saveAirportSettings,
  saveOtp,
  saveUserData
} from '../../redux/action';
import ApplicationStatus from './components/FormStatus';
import ADPStageStatus from '../Components/Stages';
import Training from '../training/training';
import ExternalTraining from '../training/ExternalTraining';
import Certificate from '../Components/Certificate';
import Result from '../Components/FailurePage';
import hindi from '../../../../translations/hn.json';
import spanish from '../../../../translations/es.json';
import english from '../../../../translations/en.json';
import french from '../../../../translations/fr.json';
import germany from '../../../../translations/ge.json';
import Language from '../Components/LanguagePage';
import UserList from '../Components/UserLists';
import Scheduling from '../AdpPublicForm/Scheduling';
import CategoryPage from '../Components/CategoryPage';
import AdpDriverPublicForm from '../AdpPublicForm/AdpDriverPublicForm';
import PaymentPage from '../Components/PaymentPage';
import { getCountryRegion } from '../../../../utils/helpers';

const url = hostName.slice(6);
class AdpLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // eslint-disable-next-line no-nested-ternary
      currentPage: props.currentPage
        ? props.currentPage
        : localStorage.getItem('current_page')
        ? localStorage.getItem('current_page')
        : 'login',
      loadingStatus: false,
      errors: {
        phoneEmpty: true,
        passwordEmpty: true,
        invalidCredentials: false,
        invalidPassword: false,
        phoneInvalid: false,
        codeEmpty: true
      },
      blurredFields: {
        phone: false,
        password: false,
        isChecked: false,
        code: false
      },
      isPaymentAvailable: false,
      cognitoPhoneError: false,
      cognitoCodeError: false,
      resendSuccess: false,
      application: {},
      currentStepper: 'training',
      certificateUrl: '',
      logo: '',
      scheduleEnable: false,
      selectedLanguage: false,
      selectedCategory: false,
      adpCategory: '',
      enable_category_training: false,
      translation: english,
      quizAnswers: {},
      userApplications: [],
      languages: [],
      category_language: [],
      categories: [],
      languageData: {},
      actualAttempts: 0,
      suportedLanguages: [
        { name: 'hindi', value: hindi },
        { name: 'english', value: english },
        { name: 'spanish', value: spanish },
        { name: 'french', value: french },
        { name: 'germany', value: germany }
      ],
      userTrainingDataAction: {
        loading: false,
        success: false,
        error: false
      },
      paymentValue: 100
    };
    const {
      match: {
        params: { installationId }
      }
    } = props;
    this.publicUrl = isLocal
      ? process.env.REACT_APP_BACKEND_PUBLICHOST
      : `https://apis.${getCountryRegion(installationId)}${url}/public`;
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputBlurred = this.handleInputBlurred.bind(this);
  }

  async componentDidMount() {
    const {
      match: {
        params: { id, installationId, airportCode }
      },
      savedApplications,
      actionFetchDataSources,
      savedOtp
    } = this.props;
    const { currentPage, currentStepper } = this.state;
    const data = { id, installationId, airportCode };
    const headers = {
      'Content-Type': 'application/json',
      Authorization: savedOtp
    };
    this.setState({ userApplications: savedApplications });
    actionFetchDataSources(data);
    if (currentPage !== 'login') {
      try {
        this.setState({ loadingStatus: true });
        await fetch(
          `${
            this.publicUrl
          }/driver_permit/logo_name/${id}/${airportCode?.toUpperCase()}`,
          { headers }
        )
          .then(response => response.json())
          .then((res) => {
            const category_language = res?.training_category
              ? Object.keys(res?.training_category)
              : [];
            const enable_category_training = res?.enable_category_training || false;
            this.setState({
              logo: res.image,
              loadingStatus: false,
              country_code: res.country_code,
              languages: res.languages,
              category_language,
              enable_category_training,
              selectedCategory: res.meta_data?.selected_category || false,
              scheduleEnable: res.scheduleEnable,
              calendar_visibility: res.calendar_visibility,
              languageData: res,
              currentStepper:
                res.status === 11
                && res.scheduleEnable
                && (res.calendar_visibility === 'both'
                  || res.calendar_visibility === 'driver')
                  ? 'payment'
                  : currentStepper
            });
            if (
              res.disable_driver_permit_online_training
              || (!res.disable_driver_permit_online_training
                && res.languages?.length === 0)
              || res.status === 1
            ) {
              this.handlePath();
            }
          });
      } catch (error) {
        this.setState({
          loadingStatus: false
        });
      }
    }
  }

  handellanguage = (value) => {
    const { suportedLanguages } = this.state;
    let index = '';
    let unSuportedLanguage = false;
    suportedLanguages.forEach((ele, i) => {
      if (value === String(ele.name)) {
        this.setState({ translation: ele.value });
        index = i;
        unSuportedLanguage = true;
      }
    });
    if (!unSuportedLanguage) {
      this.setState({ translation: english, unSuportedLanguage: true });
      localStorage.setItem('adpLanguage', JSON.stringify(english));
      this.setState({ selectedLanguage: 'english' });
    } else {
      localStorage.setItem(
        'adpLanguage',
        JSON.stringify(suportedLanguages[index])
      );
      this.setState({ selectedLanguage: value });
    }
  };

  handleCategory = (value) => {
    this.setState({ selectedCategory: value });
  };

  handelNext = () => {
    this.setState({
      currentPage: 'training',
      loadingStatus: false,
      currentStepper: 'training'
    });
    localStorage.removeItem('current_page');
    this.handlePath();
  };

  handleNextCategory = () => {
    const { languageData, selectedLanguage } = this.state;
    const categoryData = Object.keys(languageData?.training_category || {}).length === 1
        ? languageData?.training_category[
            Object.keys(languageData?.training_category)?.[0]
          ]
        : languageData?.training_category?.[selectedLanguage];
    const categories = Object.keys(categoryData);
    this.setState({ currentPage: 'category', categories });
  };

  checkValues = (value, errorKey) => {
    this.setState(prevState => ({
      errors: Object.assign({}, prevState.error, {
        [errorKey]: false
      }),
      blurredFields: Object.assign({}, prevState.error, {
        [value]: true
      })
    }));
  };

  handleUser = async (e) => {
    const { phone } = this.state;
    this.setState({ loadingStatus: true });
    if (e) {
      e.preventDefault();
    }
    let phoneNumber = phone;
    phoneNumber = phoneNumber?.[0] + phoneNumber?.slice(1).replace(/[^\d]/g, '') || '';
    const data = {
      phonenumber: phoneNumber
    };
    const headers = {
      'Content-Type': 'application/json'
    };
    Axios.post(
      `${this.publicUrl}/driver_permit/generate_otp`,
      {
        ...data
      },
      { headers }
    )
      .then(() => {
        this.setState({
          loadingStatus: false,
          currentPage: 'otpForm'
        });
      })
      .catch(() => {
        this.setState({
          loadingStatus: false,
          cognitoPhoneError: true
        });
        toast.error('Please try again later');
      });
  };

  handleResendOTP = async () => {
    this.handleUser();
  };

  validateOtpField = () => {
    if (this.state.otp === '') {
      return true;
    }
    return false;
  };

  handleLogin = async (e) => {
    const { otp, phone } = this.state;
    const { actionSaveOtp, actionGetUserApplications } = this.props;
    const hashedOtp = sha1(otp);
    actionSaveOtp(hashedOtp);
    e.preventDefault();
    this.setState({ loadingStatus: true });
    const isOTPEmpty = this.validateOtpField();
    if (!isOTPEmpty) {
      let phoneNumber = phone;
      phoneNumber = phoneNumber[0] + phoneNumber.slice(1).replace(/[^\d]/g, '');
      const data = {
        phonenumber: phoneNumber,
        otp: hashedOtp
      };
      const headers = {
        'Content-Type': 'application/json'
      };
      Axios.post(
        `${this.publicUrl}/driver_permit/authenticate_otp`,
        {
          ...data
        },
        { headers }
      )
        .then((res) => {
          if (res?.status === 200) {
            this.setState({
              loadingStatus: false,
              userApplications: res?.data?.applications,
              currentPage: 'userApplications'
            });
            actionGetUserApplications(res?.data?.applications || []);
          }
        })
        .catch(() => {
          toast.error('Please try again later');
          this.setState({
            loadingStatus: false,
            cognitoPhoneError: true
          });
        });
    } else {
      this.setState(prevState => ({
        errors: Object.assign({}, prevState.error, {
          codeEmpty: true
        }),
        blurredFields: Object.assign({}, prevState.error, {
          code: true
        }),
        cognitoCodeError: false,
        loadingStatus: false
      }));
    }
  };

 handleCategoryNextBtn = () => {
  const { selectedCategory } = this.state;
  const { match: { params: { id, airportCode } }, savedOtp } = this.props;
  const headers = {
    'Content-Type': 'application/json',
    Authorization: savedOtp
  };
    if (selectedCategory) {
      Axios.post(`${this.publicUrl}/driver_permit/update_category/${id}/${airportCode?.toUpperCase()}`, {
        selected_category: selectedCategory
      }, { headers })
      .then(() => {
        this.handelNext();
      })
      .catch(() => {
        toast.error('Please try again later');
      });
    }
  };

  onChangeRememberMe = (event) => {
    this.setState({
      isChecked: event.target.checked
    });
  };

  handleOTPLogin = () => {
    this.setState({ currentPage: 'otpLogin' });
  };

  handleOpenOtpForm = () => {
    this.setState({ currentPage: 'userApplications' });
  };

  handleChangeForgotPassword = () => {
    this.setState({
      currentPage: 'ChangeForgotpassword'
    });
  };

  changePage = (currentPage, currentStepper) => {
    this.setState({ currentPage, currentStepper });
  };

  handlePath() {
    const {
      match: {
        params: { id, airportCode }
      },
      savedOtp,
      actionSaveUserData,
      history
    } = this.props;
    const { languages, scheduleEnable, calendar_visibility } = this.state;
    this.setState({ loadingStatus: true });
    this.setState({
      userTrainingDataAction: {
        loading: true,
        success: false,
        error: false
      }
    });
    localStorage.removeItem('testAttemps');
    const headers = {
      'Content-Type': 'application/json',
      Authorization: savedOtp
    };
    Axios.get(
      `${
        this.publicUrl
      }/driver_permit/get_dp/${id}/${airportCode?.toUpperCase()}`,
      { headers }
    )
      .then(async (res) => {
        this.setState({
          loadingStatus: false,
          cognitoCodeError: true,
          adpCategory: res.data?.permit?.category_of_adp || '',
          selectedCategory: res.data.permit?.meta_data?.selected_category || false
        });
        actionSaveUserData(res.data);
        const { permit_tenant_fees } = res.data.permit?.fees_settings || {};
        let isPaymentAvailable = false;
        if (res.data?.permit?.fees_settings?.enable_permit_fees_adp) {
          if (permit_tenant_fees?.charge_fees_per_adp_permit) {
            isPaymentAvailable = permit_tenant_fees?.charge_fees_per_adp_permit;
          }
        }
        localStorage.setItem(
          'testAttemps',
          (res?.data?.permit?.tracking_info?.testAttempts
            ? res?.data?.permit?.tracking_info?.testAttempts
            : 0
          )
        );
        this.setState({ loadingStatus: true, isPaymentAvailable });
        this.setState({
          userTrainingDataAction: {
            loading: false,
            success: true,
            error: false
          }
        });
        if (
          res?.data?.permit?.status === 11
          && scheduleEnable
          && (calendar_visibility === 'both' || calendar_visibility === 'driver')
        ) {
          this.setState({
            currentPage: (isPaymentAvailable && 'payment' || 'scheduling'),
            loadingStatus: false,
            currentStepper: 'payment'
          });
        } else if (
          res?.data?.permit?.offline_training
          || res.data.disable_driver_permit_online_training
          || (!res.data.disable_driver_permit_online_training
            && languages?.length === 0)
          || res.data.permit.status === 1
        ) {
          this.setState({
            currentPage: 'publicForm',
            loadingStatus: false,
            currentStepper: 'application'
          });
        } else if (
          res.data.enable_external_training
          && res.data.permit.status === 0
        ) {
          this.setState({
            currentPage: 'externalTraining',
            loadingStatus: false,
            currentStepper: 'externalTraining'
          });
        } else if (
          !res.data.disable_driver_permit_online_training
          && (!res?.data?.permit?.test_taken || res?.data?.permit?.status === 8)
        ) {
          this.setState({
            currentPage: 'training',
            loadingStatus: false,
            currentStepper: 'training'
          });
        } else {
          this.setState({
            translation:
              !res.data.disable_driver_permit_online_training
              && JSON.parse(localStorage.getItem('adpLanguage'))?.value
                !== undefined
                ? JSON.parse(localStorage.getItem('adpLanguage')).value
                : english,
            loadingStatus: false,
            cognitoCodeError: true,
            currentPage: 'publicForm',
            currentStepper: 'application'
          });
        }
      })
      .catch(() => {
        toast.error('Please try again later');
        this.setState({
          loadingStatus: true
        });
        toast.error('Please try again later');
        setTimeout(() => {
          this.setState({
            loadingStatus: false,
            currentPage: 'login'
          });
          history.push(
            `/auth/adp/login/${this.props.match?.params?.countrycode
              || this.props.match?.params?.installationId}`
          );
          this.setState({
            userTrainingDataAction: {
              loading: false,
              success: false,
              error: true
            }
          });
        }, 2000);
      });
  }

  handleInputBlurred(inputType) {
    this.setState(prevState => ({
      blurredFields: Object.assign({}, prevState.blurredFields, {
        [inputType]: true
      })
    }));
  }

  handleInputChange(inputType, value) {
    const { cognitoPhoneError, cognitoCodeError } = this.state;
    if (value !== '' && cognitoPhoneError === true) {
      this.setState({ cognitoPhoneError: false });
    } else if (value !== '' && cognitoCodeError === true) {
      this.setState({ cognitoCodeError: false });
    }
    this.setState(
      {
        [inputType]: value
      },
      () => this.validateFormFields(inputType, value)
    );
  }

  validateFormFields(inputType, value) {
    let errors = {};
    switch (inputType) {
      case 'phone':
        if (value === '' || value === '+') {
          errors = Object.assign(errors, {
            phoneEmpty: true,
            emailInvalid: false
          });
        }
        if (value !== '+') {
          errors = Object.assign(errors, {
            phoneEmpty: false,
            emailInvalid: false
          });
        }
        break;
      case 'otp':
        if (value !== '') {
          errors = Object.assign(errors, { codeEmpty: false });
        }
        break;
      case 'password':
        errors = Object.assign(errors, { passwordEmpty: value === '' });
        break;
      default:
        break;
    }
    this.setState(prevState => ({
      errors: Object.assign({}, prevState.errors, errors)
    }));
  }

  toggleStage = () => {
    const { currentPage } = this.state;
    if (
      currentPage !== 'login'
      && currentPage !== 'otpLogin'
      && currentPage !== 'otpForm'
      && currentPage !== 'language'
      && currentPage !== 'userApplications'
      && currentPage !== 'category'
    ) {
      return true;
    }
    return null;
  };

  toggleStepper = (data) => {
    const { currentStepper } = this.state;
    if (currentStepper !== data) {
      this.setState({ currentStepper: data });
    }
    return null;
  };

  handelNavigation = (path, current_Stepper) => {
    const { userData } = this.props;
    const no_of_reattempts = Number(
        userData?.lms?.English?.sections?.[0]?.additional_config
          ?.no_of_quiz_reattempts
      ) || 1;
    const { currentStepper, actualAttempts } = this.state;
    let stepper = current_Stepper;
    if (
      path === 'training'
      && current_Stepper === 'training'
      && actualAttempts + 1 <= no_of_reattempts
    ) {
      stepper = 'quiz';
      this.setState({ actualAttempts: actualAttempts + 1 });
    } else if (path === 'training' && current_Stepper === 'training') {
      this.setState({ actualAttempts: actualAttempts + 1 });
    }
    this.setState({
      currentPage: path,
      currentStepper: stepper || currentStepper,
      reAttemptQuiz: true
    });
    return null;
  };

  handelQuizNavigation = () => {
    this.setState({
      currentPage: 'certificate',
      currentStepper: 'certificate'
    });
  };

  saveCertificate = (certificateurl) => {
    this.setState({ certificateUrl: certificateurl });
    return null;
  };

  handleQuizAnswers = (answer) => {
    this.setState({ quizAnswers: answer });
  };

  handelApplication = (data) => {
    const {
      match: {
        params: { installationId }
      },
      history
    } = this.props;
    const { scheduleEnable, calendar_visibility } = this.state;
    history.push(`/auth/adp/login/${installationId}/${data.key}/${data?.airport_code}`);
    if (data.status === 11 && scheduleEnable
      && (calendar_visibility === 'both' || calendar_visibility === 'driver')) {
      localStorage.setItem('current_page', 'payment');
    } else {
      localStorage.setItem('current_page', 'language');
    }
  };

  render() {
    const {
      currentPage,
      errors,
      blurredFields,
      isChecked,
      password,
      phone,
      otp,
      cognitoPhoneError,
      cognitoCodeError,
      loadingStatus,
      resendSuccess,
      application,
      currentStepper,
      reAttemptQuiz,
      logo,
      country_code,
      isPaymentAvailable,
      translation,
      userApplications,
      languageData,
      suportedLanguages,
      unSuportedLanguage,
      actualAttempts,
      scheduleEnable,
      quizAnswers,
      adpCategory,
      categories,
      userTrainingDataAction,
      calendar_visibility,
      selectedCategory,
      enable_category_training,
      paymentValue
    } = this.state;
    window.onload = () => {
      const {
        location: { pathname },
        history
      } = this.props;
      if (localStorage.getItem('pathname')) {
        localStorage.removeItem('current_page');
        localStorage.removeItem('adplanguage');
        this.setState({ currentPage: 'login' });
        history.push(
          `/auth/adp/login/${this.props.match?.params?.countrycode
            || this.props.match?.params?.installationId}`
        );
      } else {
        localStorage.setItem('pathname', pathname);
      }
    };

    const {
      match: {
        Url,
        params: { id, airportCode }
      },
      userData,
      actionGetUserApplications,
      history,
      savedOtp,
      user
    } = this.props;
    let formToRender;
    if (currentPage === 'login') {
      formToRender = (
        <LoginForm
          handleInputChange={this.handleInputChange}
          handleSignIn={this.handleUser}
          errors={errors}
          url={Url}
          blurredFields={blurredFields}
          handleInputBlurred={this.handleInputBlurred}
          onChangeRememberMe={this.onChangeRememberMe}
          isRemember={isChecked}
          phone={phone}
          password={password}
          handleForgotPassword={this.handleForgotPassword}
          handleOTPLogin={this.handleOTPLogin}
          cognitoPhoneError={cognitoPhoneError}
          application={application}
          {...this.props}
          img={logo}
          country_code={country_code}
          translation={translation}
        />
      );
    } else if (currentPage === 'otpLogin') {
      formToRender = (
        <OTPLoginForm
          handleInputChange={this.handleInputChange}
          errors={errors}
          blurredFields={blurredFields}
          handleInputBlurred={this.handleInputBlurred}
          phone={phone}
          handleUser={this.handleUser}
        />
      );
    } else if (
      currentPage === 'language'
      && languageData
      && Object.keys(languageData)?.length > 0
    ) {
      formToRender = (
        <Language
          handelLanguage={this.handellanguage}
          selectedLanguage={this.state.selectedLanguage}
          handelNext={
            enable_category_training === true
              ? this.handleNextCategory
              : this.handelNext
          }
          languages={
            enable_category_training === true
              ? this.state.category_language
              : this.state.languages
          }
        />
      );
    } else if (currentPage === 'category') {
        formToRender = (
          <CategoryPage
            handleCategory={this.handleCategory}
            selectedCategory={selectedCategory}
            handleCategoryNextBtn={this.handleCategoryNextBtn}
            categories={categories}
          />
        );
    } else if (currentPage === 'otpForm') {
      formToRender = (
        <OTPForm
          handleInputChange={this.handleInputChange}
          errors={errors}
          blurredFields={blurredFields}
          handleInputBlurred={this.handleInputBlurred}
          cognitoCodeError={cognitoCodeError}
          otp={otp}
          handleLogin={this.handleLogin}
          handleResendOTP={this.handleUser}
          resendSuccess={resendSuccess}
          img={logo}
        />
      );
    } else if (currentPage === 'publicForm') {
      formToRender = (
        <AdpDriverPublicForm
          changePage={this.changePage}
          translation={translation}
          countrycode={country_code}
          selectedCategory={selectedCategory}
          isPaymentAvailable={isPaymentAvailable}
          {...this.props}
        />
      );
    } else if (currentPage === 'training') {
      formToRender = (
        <Training
          currentStepper={currentStepper}
          changeStepper={this.toggleStepper}
          saveCertificate={this.saveCertificate}
          navigateTo={this.handelNavigation}
          reAttemptQuiz={reAttemptQuiz}
          translation={translation}
          suportedLanguages={suportedLanguages}
          unSuportedLanguage={unSuportedLanguage}
          handleGetAdpData={this.handlePath}
          currentAttempts={actualAttempts}
          selectedCategory={selectedCategory}
          handleQuizAnswers={this.handleQuizAnswers}
          userTrainingDataAction={userTrainingDataAction}
          {...this.props}
        />
      );
    } else if (currentPage === 'externalTraining') {
      formToRender = (
        <ExternalTraining
          changePage={this.changePage}
          userData={userData}
          savedOtp={savedOtp}
          id={id}
          publicUrl={this.publicUrl}
          airportCode={airportCode}
        />
      );
    } else if (currentPage === 'formStatus') {
      formToRender = <ApplicationStatus userData={userData} />;
    } else if (currentPage === 'certificate') {
      formToRender = (
        <Certificate
          {...this.props}
          navigateToApplication={() => {
            this.setState({
              currentPage: 'publicForm',
              currentStepper: 'application'
            });
          }}
          certificateUrl={this.state.certificateUrl}
          translation={translation}
          suportedLanguages={suportedLanguages}
          unSuportedLanguage={unSuportedLanguage}
          quizAnswers={quizAnswers}
          installationId={this.props.match?.params?.installationId}
          countrycode={country_code}
          actionGetUserApplications={actionGetUserApplications}
        />
      );
    } else if (currentPage === 'fail') {
      formToRender = (
        <Result
          {...this.props}
          suportedLanguages={suportedLanguages}
          enable_category_training={this.props?.userData?.enable_category_training}
          applicationDetails={this.props?.userData}
          selectedCategory={selectedCategory}
          handelNavigation={this.handelNavigation}
          installationId={this.props.match?.params?.installationId}
          translation={translation}
        />
      );
    } else if (currentPage === 'userApplications') {
      formToRender = (
        <UserList
          applications={userApplications}
          handelNavigation={this.handelNavigation}
          handelApplication={this.handelApplication}
          {...this.props}
        />
      );
    } else if (currentPage === 'payment') {
      formToRender = (
        <PaymentPage
          user={user}
          paymentData={paymentValue}
          profileCurrency={
            user?.portal_airport?.airport_settings?.currency || '$'
          }
          handelNavigation={this.handelNavigation}
          statusBar={userData.disable_driver_permit_online_training}
          airportSettings={user?.portal_airport?.airport_settings}
          paymentModule="driver_permit"
        />
      );
    } else if (currentPage === 'scheduling') {
      formToRender = (
        <Scheduling
          changePage={this.changePage}
          history={history}
          Uichange={userData.disable_driver_permit_online_training}
        />
      );
    }

    return (
      <div
        className={`${styles.authentication} ${currentPage
          === 'userApplications' && styles.userListMobileResponsive}`}
        style={{
          display: this.toggleStage() ? 'block' : 'flex',
          zIndex: '9',
          background: this.toggleStage() ? 'white' : ''
        }}
      >
        <Loading loadingStatus={loadingStatus} />
        <div>
          {this.toggleStage() && (
            <div className={styles.logo_container}>
              <img src={logo} alt="logo" className={styles.logo} />
              <p
                className={styles.ptag}
                style={{ fontWeight: 'bold', color: '#fff' }}
              >
                {userData.permit_management_nomenclature?.driver_permit
                  || 'ADP'}
              </p>
            </div>
          )}
          {userData
            && Object.keys(userData)?.length > 0
            && !userData.disable_driver_permit_online_training
            && this.toggleStage() && (
              <ADPStageStatus
                current_stage={currentStepper}
                translation={translation}
                userData={userData}
                scheduleEnable={userData?.scheduleEnable || scheduleEnable}
                calendarVisibility={
                  calendar_visibility === 'both'
                  || calendar_visibility === 'driver'
                }
              />
            )}
          <div
            className={styles.form_container}
            style={{ width: currentPage === 'userApplications' ? '96vw' : '' }}
          >
            {formToRender}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  savedOtp: state.permitManagement.otp,
  currentPage: state.permitManagement.currentPage,
  userData: state.permitManagement.userData,
  savedApplications: state.permitManagement.userApplications,
  user: state.auth.profile
});

const mapDispatchToProps = dispatch => ({
  actionFetchDataSources: (data) => {
    dispatch(saveAirportSettings(data));
  },
  actionSaveOtp: (otp) => {
    dispatch(saveOtp(otp));
  },
  actionSaveUserData: (userdata) => {
    dispatch(saveUserData(userdata));
  },
  actionGetUserApplications: (data) => {
    dispatch(fetchUserApplications(data));
  }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AdpLogin));
